import React from 'react';
import { StyleSheetManager } from 'styled-components';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';

import App from './App';
import { RootContext, RootStore } from './store/rootStore';
import apolloClient from './api/apolloClient';
import './assets/css/index.css';

const styledCompsInsertionPoint = document.getElementById('styled-components-insertion-point')!;
const rootEl = document.getElementById('root')!;
const root = createRoot(rootEl);

root.render(
  <StyleSheetManager target={styledCompsInsertionPoint}>
    <React.StrictMode>
      <RootContext.Provider value={new RootStore()}>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </RootContext.Provider>
    </React.StrictMode>
  </StyleSheetManager>,
);
